/* eslint-disable jsx-a11y/media-has-caption */
import React from 'react';
import PropTypes from 'prop-types';
import styled from '@emotion/styled';

const Video = styled.video`
  display: block;
  height: auto;
  object-fit: cover;
  width: 100%;
  margin: 1.5rem auto 2rem;
`;

const CardHeroVideo = ({
  videoUrl,
  playsInline,
  posterURL,
}) => (
  <div>
    <Video
      controls
      preload="meta"
      poster={posterURL}
      playsInline={playsInline}
    >
      <source src={videoUrl} type="video/mp4" />
    </Video>
  </div>
);

CardHeroVideo.propTypes = {
  playsInline: PropTypes.bool,
  videoUrl: PropTypes.string.isRequired,
  posterURL: PropTypes.string,
};

CardHeroVideo.defaultProps = {
  playsInline: false,
  posterURL: undefined,
};

export default CardHeroVideo;
